<div>
    <div widget class="card border-0 box-shadow">
        <div class="card-header transparent text-muted">
            <h4 class="font-header col-lg-10 col-md-10 col-sm-6 col-xs-6">
                Claim Bill
            </h4>

        </div>
        <div class="card-body pt-2">
            <div class="row">
                <div class="col-3 borderstyle">
                    <div class="d-flex mb-1">
                        <label class="label-font">Payer&nbsp;:&nbsp; </label>
                        <label class="label-font">{{ClaimEditBo.payer_PayorName}}</label>
                    </div> <br>
                    <div class="d-flex mb-1">
                        <label class="label-font">Total charges&nbsp;:&nbsp;$ &nbsp;</label>
                        <label class="label-font">{{ClaimEditBo.totalAmount}}</label>
                        <!--  -->
                    </div>
                    <div class="d-flex mb-1">
                        <label class="label-font">Amount Paid&nbsp;:&nbsp;$ &nbsp;</label>
                        <label class="label-font">{{ClaimEditBo.paidAmount}}</label>
                        <!--  -->
                    </div>
                    <div class="d-flex mb-1">
                        <label class="label-font">Balance Due&nbsp;:&nbsp;$ &nbsp;</label>
                        <label class="label-font">{{ClaimEditBo.balanceDueAmount}}</label>
                        <!--  -->
                    </div>
                </div>
                <div class="col-5 px-4 borderstyle">
                    <div class="d-flex mb-1">
                        <label class="label-font col-4">Resubmission code</label>
                        <ng-select class="col" [searchable]="true" [clearable]="true" [items]="ResubmissionTypeList"
                            bindLabel="lovName" bindValue="id" [(ngModel)]="ClaimEditBo.resubmissionTypeLid">
                        </ng-select>
                    </div>
                    <div class="d-flex mb-1">
                        <label class="label-font col-4 ">Payer Claim Control #</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payerClaimReferenceNumber" >
                    </div>
                    <div class="d-flex">
                        <label class="label-font col-4 ">Notes</label>
                        <textarea class="form-control" [(ngModel)]="ClaimEditBo.claimNote"></textarea>
                    </div>                
                </div>
                <div class="text-end col-4 ">
                    
                    <button class="btn btn-sm me-5 mt-1" [disabled]="IsButtonDisable" (click)="saveEditClaim()"  *ngIf="fp.readytobillupdate || fp.activeclaimsupdate || fp.achieveclaimsupdate">
                        Update
                    </button>
                    <button class="btn btn-sm me-3 mt-1" (click)="backToClaimList()">
                        Close
                    </button>
                </div>

                <div class="mt-4">
                    <h5><strong>Client</strong></h5>
                </div>
                <hr class="mt-0">
                <div class="row">
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">First Name</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.client_FirstName">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Middle Name</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.client_MiddleName">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Last Name</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.client_LastName">
                    </div>

                    <div class="col-lg-4 col-6 d-flex mb-1">
                        <label class="label-font col-lg-4 col-6">DOB</label>
                        <my-date-picker class="col" [selDate]="client_DOB" [options]="myDatePickerOptions"
                            (inputFieldChanged)="DateFormat($event,'inputchanged','DOB')"
                            (dateChanged)="DateFormat($event,'datechanged','DOB')"></my-date-picker>
                    </div>

                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Street</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.client_Street">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">City</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.client_City">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">State</label>
                        <ng-select class="col" [items]="stateList" [searchable]="true" [clearable]="true"
                            bindLabel="name" bindValue="abbreviation" [ngModel]="ClaimEditBo.client_State"></ng-select>
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Zip Code</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.client_ZipCode">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Apt</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.client_Apt">
                    </div>

                </div>


                <div class="mt-4">
                    <h5><strong>Company</strong></h5>
                </div>
                <hr class="mt-0">
                <div class="row">
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Company Name</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.company_Name">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Admin Name</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.company_AdminFullName">
                    </div>

                    <div class="col-lg-4 col-6 d-flex mb-1">
                        <label class="label-font col-lg-4 col-6">FEIN</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.company_FEIN">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-1">
                        <label class="label-font col-lg-4 col-6">Phone</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.company_PhoneNumber">
                    </div>

                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Street</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.company_Street">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">City</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.company_City">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">State</label>
                        <ng-select class="col" [items]="stateList" [searchable]="true" [clearable]="true"
                            bindLabel="name" bindValue="abbreviation" [ngModel]="ClaimEditBo.company_State"></ng-select>
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Zip Code</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.company_ZipCode">
                    </div>
                </div>
                <div class="mt-4">
                    <h5><strong>Payor</strong></h5>
                </div>
                <hr class="mt-0">
                <div class="row">
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Name</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payer_PayorName">
                    </div>

                    <div class="col-lg-4 col-6 d-flex mb-1">
                        <label class="label-font col-lg-4 col-6">NPI</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payer_NPI">
                    </div>

                    <div class="col-lg-4 col-6 d-flex mb-1">
                        <label class="label-font col-lg-4 col-6">Provider Number</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payerCompanyMap_ProviderNumber">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-1">
                        <label class="label-font col-lg-4 col-6">Taxonomy Code</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payerCompanyMap_TaxonomyCode">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-1">
                        <label class="label-font col-lg-4 col-6">G2Id</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payerServiceMap_G2Id">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">AddressLine1</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payer_AddressLine1">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">AddressLine1</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payer_AddressLine2">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">City</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payer_City">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">State</label>
                        <ng-select class="col" [items]="stateList" [searchable]="true" [clearable]="true"
                            bindLabel="name" bindValue="abbreviation" [ngModel]="ClaimEditBo.payer_State"></ng-select>
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Zip Code</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payer_Zip">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">CalimFilling Indicator Code</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.payer_ClaimFilingIndicatorCode">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Rendering Provider Code</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo. payerServiceMap_RenderingProviderLovCode">
                    </div>
                </div>

                <div class="mt-4">
                    <h5><strong>Authorization Information</strong></h5>
                </div>
                <hr class="mt-0">
                <div class="row">
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">ICD10 Code</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.auth_ICD10Code">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-lg-4 col-6">Insurance Number</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.auth_InsuranceNumber">
                    </div>
                    <div class="col-lg-4 col-6 d-flex mb-2">
                        <label class="label-font col-6">Service Agreement Number</label>
                        <input class="form-control" [(ngModel)]="ClaimEditBo.auth_ServiceAgreementNumber">
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 mt-3 ms-2">
                        <h5><strong>Service Line </strong></h5>
                    </div>
                    <div class="row mb-3 mt-3">
                        <div class="col-lg-12">
                            <button type="button" class="btn blue-btn btn-sm ms-2 mb-1" [disabled]="showEditorView"
                                data-bs-toggle="modal" data-bs-target="#paidAmountUpdateSModal"
                                (click)="editPaidAmount();">
                                Manually Post Payment
                            </button>
                            <button *ngIf="EditClaim?.claimGridType != 'PurchaseRequest'" type="button" class="btn blue-btn btn-sm ms-2 mb-1" [disabled]="showEditorView"
                                data-bs-toggle="modal" data-bs-target="#updatetimesheetmodal"
                                (click)="openverification = true;updateTransaction();">
                                Update {{EditClaim?.claimGridType}}
                            </button>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-12 ms-2">
                            <ejs-grid class="p-0" [dataSource]='BatchServiceLineList' [filterSettings]='filterSettings'
                                [allowFiltering]='true' [showColumnChooser]='true' [allowSorting]='true'
                                [rowHeight]='30' [allowResizing]='true'>
                                <e-columns class="p-0">
                                    <e-column field='serviceDate' headerText='Service Date' textAlign='Center' [allowFiltering]="false" [allowSorting]="false"
                                        minwidth=100 type="datetime" [format]='formatDateOptions'>
                                    </e-column>
                                    <e-column field='serviceCode' headerText='Service Code' textAlign='Center'
                                        minwidth=100 type="string">
                                    </e-column>
                                    <e-column field='modifier1' headerText='Service Modifier' textAlign='Center'
                                        minwidth=100 type="string">
                                    </e-column>
                                    <e-column field='serviceName' headerText='Service Name' textAlign='Center'
                                        minwidth=100 type="string">
                                    </e-column>

                                    <e-column field='totalAmount' headerText='Total Amount' textAlign='Center'
                                        minwidth=100 type="number">
                                    </e-column>


                                    <e-column field='postedDate' headerText='Posted Date' textAlign='Center' [allowFiltering]="false" [allowSorting]="false"
                                        minwidth=100 type="datetime" [format]='formatDateOptions'>
                                    </e-column>
                                    <e-column field='paidDate' headerText='Paid Date' textAlign='Center' minwidth=100 [allowFiltering]="false" [allowSorting]="false"
                                        type="datetime" [format]='formatDateOptions'>
                                    </e-column>
                                    <e-column field='paidAmount' headerText='Payer Paid' textAlign='Center' minwidth=100
                                        type="number">
                                    </e-column>
                                    <e-column field='balanceDueAmount' headerText='Balance Due' textAlign='Center'
                                        minwidth=100 type="number">
                                    </e-column>
                                    <e-column field='denialAmount' headerText='Denial Amount' textAlign='Center'
                                        minwidth=100 type="string">
                                    </e-column>
                                     <e-column field='units' headerText='Units' textAlign='Center'
                                        minwidth=100 type="string">
                                    </e-column>
                                    <e-column headerText='Denial Details' textAlign='Center'>
                                        <ng-template #template let-data>

                                            <i class="fa fa-eye" *ngIf="denialList?.length > 0"
                                                style="font-size: 18px;text-align: center;" data-bs-toggle="collapse"
                                                data-bs-target="#collapseExample" aria-expanded="false"
                                                aria-controls="collapseExample">

                                            </i>
                                        </ng-template>

                                    </e-column>

                                </e-columns>
                            </ejs-grid>
                            <div class="collapse" id="collapseExample">
                                <div class="card card-body">
                                    <ejs-grid class="p-0" [dataSource]='denialList' [filterSettings]='filterSettings'
                                        [allowFiltering]='true' [showColumnChooser]='true' [allowSorting]='true'
                                        [rowHeight]='30' [allowResizing]='true'>
                                        <e-columns class="p-0">
                                            <e-column field='adjustmentGroupCode' headerText='Denial Code'
                                                textAlign='Center' minwidth=100 type="string">
                                            </e-column>
                                            <e-column field='adjustmentReasonCode' headerText='Denial ReasonCode'
                                                textAlign='Center' minwidth=100 type="string">
                                            </e-column>
                                            <e-column field='adjustmentAmount' headerText='Denial Amount'
                                                textAlign='Center' minwidth=100 type="number">
                                            </e-column>

                                        </e-columns>
                                    </ejs-grid>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>


<!-----------------------------------Claim Service Line Paid Details------------------------------------>
<span id="paidAmountUpdateSModalSpan" data-bs-toggle="modal" data-bs-target="#paidAmountUpdateSModal"></span>
<div class="modal fade" id="paidAmountUpdateSModal" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">

                <h5 class="modal-title font-header">Manually Post Payment Details</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12">
                        <div class="table-responsive">
                            <table class="tableclass table-hover table-bordered">
                                <thead>
                                    <tr class="row1" style="text-align: center">
                                        <th class="pointer"
                                            style="min-width: 100px;position: relative;color:white;background-color:  #502189;">
                                            Service Date</th>
                                        <th class="pointer" style="min-width: 50px">Service Code</th>
                                        <th class="pointer" style="min-width: 50px">Service Modifier</th>
                                        <th class="pointer" style="min-width: 50px">Service Name</th>
                                        <th class="pointer" style="min-width: 70px">Total Amount</th>
                                        <th class="pointer" style="min-width: 80px">Posted Date</th>
                                        <th class="pointer" style="min-width: 120px">Paid Date</th>
                                        <th class="pointer" style="min-width: 80px">Paid Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="row1">
                                        <td class="tab"
                                            style="text-align: left;position: relative;background-color: whitesmoke;">
                                            {{ ClaimEditBo?.claimServiceLine?.serviceDate| date: "MM/dd/yyyy" }}
                                        </td>
                                        <td class="tab" style="text-align: left;background-color: whitesmoke">{{
                                            ClaimEditBo?.claimServiceLine?.serviceCode}}</td>
                                        <td class="tab" style="text-align: left;background-color: whitesmoke">{{
                                            ClaimEditBo?.claimServiceLine?.modifier1}}</td>
                                        <td class="tab" style="text-align: left;background-color: whitesmoke">{{
                                            ClaimEditBo?.claimServiceLine?.serviceName}}</td>
                                        <td class="tab" style="text-align: left;background-color: whitesmoke">{{
                                            ClaimEditBo?.claimServiceLine?.totalAmount}}</td>
                                        <td class="tab"
                                            style="text-align: left;position: relative;background-color: whitesmoke;">
                                            {{ ClaimEditBo?.claimServiceLine?.postedDate| date: "MM/dd/yyyy" }}
                                        </td>
                                        <td class="tab" style="text-align: left;background-color: whitesmoke"
                                            *ngIf="ClaimEditBo?.claimServiceLine!=null&&ClaimEditBo?.claimServiceLine!=''">
                                            <my-date-picker id="manualpostpicker" [options]="myDatePickerOptions"
                                                [selDate]="ClaimEditBo.claimServiceLine.paidDateFormated"
                                                placeholder="mm/dd/yyyy"
                                                (inputFieldChanged)="paidChange($event, ClaimEditBo.claimServiceLine)"
                                                (dateChanged)="onPaiddatechanged($event, ClaimEditBo.claimServiceLine)">
                                            </my-date-picker>
                                        </td>
                                        <td class="tab" style="text-align: left;background-color: whitesmoke"
                                            *ngIf="ClaimEditBo?.claimServiceLine!=null&&ClaimEditBo?.claimServiceLine!=''">
                                            <input type="string" (keypress)="decimalOnly($event)"
                                                [(ngModel)]="ClaimEditBo.claimServiceLine.paidAmount" />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm" [disabled]="IsButtonDisable" (click)="updatePaidAmount()">
                    Update & Close
                </button>
                <button type="button" class="btn btn-sm ms-2" data-bs-dismiss="modal">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<!-- app-timesheetverification -->
<span id="openupdatetimesheet" data-bs-target="#updatetimesheetmodal" data-bs-toggle="modal"></span>
<div class="modal fade" id="updatetimesheetmodal" aria-hidden="true" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title font-header">Update Timesheet</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="openverification = false;" aria-label="Close">
                    <span aria-hidden="true"></span>
                </button>
            </div>
            <div class="modal-body scroll">
                <app-verifications [fromClaim]="timesheetVerificationInput" (outclaim)="fromtimesheetverification($event)" *ngIf="openverification">
                </app-verifications>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-sm ms-2" data-bs-dismiss="modal" (click)="openverification = false;">
                    Close
                </button>
            </div>
        </div>
    </div>
</div>